import config from '../../config';

const TOP_Y = -425;
const BOTTOM_Y = config.HEIGHT + 425;
const FLY_OVER_DURATION = 3000;

let soundManager;

class Knight {
  constructor (gameContext) {
    this.g = gameContext;
    let g = this.g;

    soundManager = g.scene.get('SoundManager');

    this.x = config.CENTER_X;
    this.y = BOTTOM_Y;

    let cape = g.add.sprite(this.x, this.y, 'knight');
    cape.play('transition-cape');
    this.cape = cape;
    let body = g.add.sprite(this.x, this.y, 'knight', 'Knight_00.png');
    let boost = g.add.sprite(this.x, this.y, 'knight');
    boost.play('boost-and-glow');

    this.sprites = [ cape, body, boost ];
  }
  setActive (bool) {
    _.each(this.sprites, (sprite) => {
      sprite.setActive(bool);
      sprite.setVisible(bool);
    });
  }
  setPosition (x, y) {
    this.x = x;
    this.y = y;
    _.each(this.sprites, (sprite) => {
      sprite.setPosition(x, y);
    });
  }
  flyOver (onHalfComplete, onComplete) {
    let g = this.g;
    this.setActive(true);

    this.setPosition(config.CENTER_X, BOTTOM_Y);

    _.each(this.sprites, (s) => {
      g.children.bringToTop(s);
    });

    soundManager.playSound('jet-boost');

    g.time.delayedCall(FLY_OVER_DURATION / 2, () => {
      if (onHalfComplete) {
        onHalfComplete();
      }
    });

    g.tweens.add({
      targets: this.sprites,
      y: TOP_Y,
      ease: 'Linear',
      duration: FLY_OVER_DURATION,
      onComplete: () => {
        this.y = TOP_Y;
        this.setActive(false);
        if (onComplete) {
          onComplete();
        }
      }
    });
  }
  hover () {
    let g = this.g;
    this.setActive(true);

    this.setPosition(config.CENTER_X, BOTTOM_Y);

    this.cape.play('end-cape');

    let tl = g.tweens.createTimeline();

    soundManager.playSound('jet-boost');

    tl.add({
      targets: this.sprites,
      y: config.CENTER_Y + 180,
      duration: 2000,
      ease: 'Cubic.easeOut'
    });

    tl.add({
      targets: this.sprites,
      y: config.CENTER_Y + 200,
      duration: 2000,
      ease: 'Quad.easeInOut',
      repeat: -1,
      yoyo: true
    });

    tl.play();
  }
}

export default Knight;
